const css = `.nro0WG__container{background-color:var(--special-intelligence-surfaces-secondary)}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"container":"nro0WG__container"};
